<template>
  <PopupCommon
    :modalTitle="modalTitle"
    :modalActive="modalResetActive"
    @update:close="closeModal"
    :maxWidth="'530'"
  >
    <template #content>
      <template v-if="!messageSuccess">
        <div class="fs-16 lh-20 mb-20">We will send a link to the email below to reset your password.</div>
        <form @submit.prevent novalidate>
          <div class="mb-20" v-bind:class="{ errorClass : errors.emailForgotPass }">
            <label class="ttu fw-900 fs-11 gray-dark mb-8 dib">email</label>
            <Input
              type="email"
              placeholder="Email"
              name="emailForgotPass"
              id="emailForgotPass"
              autocomplete="email"
              v-model="email"
            ></Input>
            <div class="error-message" v-if="errors.emailForgotPass">
              {{ errors.emailForgotPass }}
            </div>
          </div>
          <div class="tc">
            <ButtonLoading v-if="loading" btnClass='button button-primary wp-100' />
            <button
              class="button button-primary wp-100"
              v-else
              @click="handleReset"
            >
              Send Reset Link
            </button>
          </div>
        </form>
      </template>
      <div class="pa-60 pt-20" v-else>
        <h1 class="tc fs-36 fw-900 lh-36 mt-0 mb-20 mb-fs-28 mb-lh-28">
          Password Reset
        </h1>
        <div class="fs-14 lh-22 black">{{ messageSuccess }}</div>
      </div>
    </template>
    <div
      id="errorMessages"
      class="red bg-red-900 tc pt-20 pb-20 pl-30 pr-30 mt-23 lh-17"
      v-if="messageError"
      v-html="messageError"
    >
    </div>
  </PopupCommon>

</template>

<script>
import Input from "~/components/ui/input/Input"
import ButtonLoading from "~/components/ui/loading-button/ButtonLoading"
import {computed, ref, watchEffect} from "vue"
import useFormValidation from '~/utils/validators'
import PopupCommon from '~/components/ui/popup/PopupCommon'
import { useAuthStore } from '~/store/pinia/auth'

export default {
  name: "SectionForgotPassword",
  components: {PopupCommon, ButtonLoading, Input},
  props: ['emailInput', 'modalResetActive'],
  emits: ['update:modalResetActive'],
  setup(props, { emit }) {
    const loading = ref(false)
    const email = ref(props.emailInput)
    const messageSuccess = ref('')
    const messageError = ref('')
    const modalTitle = ref('Reset Password')
    const authStore = useAuthStore()
    const { validateEmailField, errors } = useFormValidation()

    const handleReset = async() => {
      validateEmailField('emailForgotPass', email.value, 'auth')

      if (!errors.emailForgotPass) {
        loading.value = true
        try{
          await authStore.forgotPassword({
            email: email.value,
          })
          const state = computed(() => authStore.auth)
          if (state.value.error === 0) {
            messageSuccess.value = state.value.message
            messageError.value = ''
            modalTitle.value = ''
            loading.value = false
          } else{
            messageError.value = state.value.message
            loading.value = false
          }
        }catch(err){
          console.log(err)
        }
      } else {
        loading.value = false
      }
    }

    const closeModal = (data) => {
      emit('update:modalResetActive', data)
      messageSuccess.value = ''
      errors.emailForgotPass = ''
      messageError.value = ''
      modalTitle.value = 'Reset Password'
    }

    watchEffect(()=>{
      email.value = props.emailInput
    })

    return {
      email,
      handleReset,
      messageSuccess,
      messageError,
      errors,
      loading,
      modalTitle, closeModal
    }
  }
}
</script>

<style scoped>

</style>
